<template>
    <v-list>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/historial">
            <v-list-tile-action>
                <v-icon>date_range</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('Historial')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                v-if="providerHasParkingModule"
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/transportistas">
            <v-list-tile-action>
                <v-icon>local_shipping</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile>Transportistas</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="providerHasParkingModule"></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/configuracion">
            <v-list-tile-action>
                <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('configuracion')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile
                class="tile"
                active-class="blue-grey darken-1 white--text"
                router to="/ayuda_admin">
            <v-list-tile-action>
                <v-icon>help</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
                <v-list-tile >{{$t('Ayuda')}}</v-list-tile>
            </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
    </v-list>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: "empleado_proveedor",
        computed: {
                    ...mapGetters(['getProfile', 'providerHasParkingModule'])
        },
        data () {
            return {
            }
        }
    }
</script>
